export const shake = [0, -50, 50, -50, 50, 0];

export const wiggle = [0, -20, 20, -20, 20, 0];

export const pulse = {
    scale: [1, 0.85, 1.08, 0.9, 1],
    transition: {
        repeat: Infinity,
        duration: 2.5,
    },
};

export const heavyPulse = {
    scale: [1, 0.8, 1.2, 0.7, 1],
    transition: {
        repeat: Infinity,
        duration: 2,
    },
};

export const initialPulse = {
    scale: 1,
};
